import clsx from 'clsx';
import React from 'react';
import { has } from '../../../services';
import { Icon, IconName } from '../../icon';
import { InfoBlockStatus } from '../InfoBlockEnum';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
import { Text, TextLevels } from '../../text';
import { TypographyBold } from '../../../objects';
/**
 * Info Block Header
 * @param children {string} Header title content
 * @param status {InfoBlockStatus} Icon + status for header => SUCCESS|WARNING|ERROR
 * @param customIcon {IconName} Custom Icon for Info Block Header, if CustomIcon status props wont work
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 */
const InfoBlockHeader = ({ className, status, children, customIcon, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('info-block-header', has('text-centered'), className));
    const _iconName = React.useMemo(() => {
        if (customIcon != null)
            return customIcon;
        else if (status === InfoBlockStatus.WARNING)
            return IconName.EXCLAMATION_CIRCLE;
        else if (status === InfoBlockStatus.ERROR)
            return IconName.TIMES_CIRCLE;
        else
            return IconName.CHECK_CIRCLE;
    }, [status, customIcon]);
    return (React.createElement("header", { className: classes, ...others },
        customIcon && !status ? (customIcon) : (React.createElement(Icon, { name: _iconName, className: clsx('is-large', status === InfoBlockStatus.DANGER && 'is-danger', status === InfoBlockStatus.ERROR && 'is-error', status === InfoBlockStatus.WARNING && 'is-warning', status === InfoBlockStatus.SUCCESS && 'is-success') })),
        React.createElement("span", null, children && typeof children.valueOf() === 'string' ? (React.createElement(Text, { level: TextLevels.ONE, typo: TypographyBold.TEXT_WEIGHT_SEMIBOLD }, children)) : (children))));
};
export default InfoBlockHeader;
//# sourceMappingURL=InfoBlockHeader.js.map